import {Component, OnInit, OnDestroy, AfterViewInit} from '@angular/core';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import { ActivatedRoute, Router } from '@angular/router';
import { StorageService } from '../../../Services/storage.service';
import {DataService} from '../../../Services/data.service';
import { Title } from '@angular/platform-browser';
import { DateFilterService } from '../../../Services/dateFilter.service';
import { FilterPipe } from 'ngx-filter-pipe';
import { AppConfigService } from '../../../Services/app-config.service';
import { DecimalNewPipe } from '../../common/DecimalNewPipe';
import { ResponseModel } from '../../../DataModels/response-model';
import {ViewportScroller } from '@angular/common';
import {Subscription} from 'rxjs';
import { NgbPaginationConfig } from '@ng-bootstrap/ng-bootstrap';
import { PagerStateService } from '../../../Services/pager-state.service';
import { NgbpaginationConfigService } from '../../../Services/ngbpagination-config.service';
import {BsToastService} from '../../../Services/bs-toast-service';
import {ConfirmDialogService} from '../../../Services/confirm-dialog.service';
import {PermissionsService} from '../../../Services/permissions.service';
import {ListPageBase} from '../../list-page-base';

@Component({
  selector: 'app-entry-list',
  templateUrl: './entry-list.component.html',
  styleUrls: ['./entry-list.component.css'],
  standalone: false
})
export class EntryListComponent extends ListPageBase implements OnInit, AfterViewInit, OnDestroy {

  constructor(
    private route: ActivatedRoute,
    private localStorage: StorageService,
    private tableDataService: DataService,
    private notification: BsToastService,
    private dateFilter: DateFilterService,
    private titleService: Title,
    private decimalPipe: DecimalNewPipe,
    private vps: ViewportScroller,
    private ngbConfig: NgbPaginationConfig,
    private pagerConfig: NgbpaginationConfigService,
    public confirmDialogService: ConfirmDialogService,
    private permissionsService: PermissionsService
  ) {
    super();
    this.ngbConfig = this.pagerConfig.getNgbPaginationConfig();
    this.vm.entryFilter = { text: '' };
    this.vm.batches = [];
    this.vm.selectItems = false;

  }
  subscriptionGroup: Subscription[] = [];

  get hasEditJournalEntryPermission(): boolean {
    return this.permissionsService.Get('Admin') ||
      this.permissionsService.Get('EditJournalEntries');
  }

  public vm: any = {
    title: $localize`:Journal Entries @@journalEntries:Journal Entries`,
    Preferences: [],
    permissions: [],
    listData: [],
    listInitiated: false,
    sysUserFilter: { text: null },
    formRouter: '/transactions/entry/form',
    include: 'all'
  };
  isLoaded = false;
  EntryCount = 0;

  checkAll = false;
  selectedRecords = [];

  // legacy angular-datatables removed



  ngOnInit() {
    this.restorePagerState();
    this.subscriptionGroup.push(this.route.params.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(params => {
      this.init();
    }));
  }

  init() {
    this.vm.owingSelected = this.vm.totalSelected = 0;
    this.vm.Preferences = JSON.parse(this.localStorage.StorageGet('Preferences'));
    this.vm.permissions = JSON.parse(this.localStorage.StorageGet('Permissions'));
    this.vm.batchesHidden = !this.vm.Preferences.ShowBatches;

    if (!this.vm.permissions.EditReceivableInvoices && !this.vm.permissions.ViewReceivableInvoices &&
      !this.vm.permissions.EditPayableInvoices && !this.vm.permissions.ViewPayableInvoices && !this.vm.permissions.EditQuotes &&
      !this.vm.permissions.ViewQuotes && !this.vm.permissions.EditSalesOrders && !this.vm.permissions.ViewSalesOrders &&
      !this.vm.permissions.EditPurchaseOrders && !this.vm.permissions.ViewPurchaseOrders && !this.vm.permissions.Admin) {
      document.location.href = '/';
    }

    this.vm.entryNumberOfResults = this.appConfig.maxRecords;

    // this.subscriptionGroup.push(this.tableDataService.getApiListData('account', '?state=active&pageNumber=0&pageSize=999999')
    //   .subscribe((account: any[]) => {
    //   // this.localStorage.StorageSet('account', JSON.stringify(account));
    // }));
    this.titleService.setTitle(this.vm.title);

    // Restore pager from enhanced per-tab cache (sessionStorage + memory); legacy observable removed
    this.search();
    this.vm.listData = [];
  }

  ngOnDestroy(): void {
    this.subscriptionGroup.forEach(subscription => {
      subscription.unsubscribe();
    });
  }

  clearServerSearch(value) {
    this.vm.entrySearch = value.searchTerm;
    this.vm.entryFromDate = value.fromDate;
    this.vm.entryToDate = value.toDate;
    this.page = 1;
    this.getPagedApiData();
  }

  protected fetchPage(): void {
    this.getPagedApiData();
  }

  getPagedApiData() {
    this.isLoaded = false;
    this.vm.searching = true;
    this.vm.batchId = undefined;
    this.vm.tempDescription = '';

    let paramString = '';
    paramString += 'search=' + ((this.vm.entrySearch) ? this.vm.entrySearch : '');
    paramString += '&batchId=' + ((this.vm.batchId) ? this.vm.batchId : '');
    paramString += '&fromDate=' + ((this.vm.entryFromDate) ? this.dateFilter.GetDateFormat(this.vm.entryFromDate) : '');
    paramString += '&toDate=' + ((this.vm.entryToDate) ? this.dateFilter.GetDateFormat(this.vm.entryToDate) : '');
    paramString += '&numberOfResults=' + ((this.vm.entryNumberOfResults) ? this.vm.entryNumberOfResults : '');
    paramString += '&include=' + ((this.vm.include) ? this.vm.include : 'all');
    paramString += '&pageNumber=' + ((this.page !== 0) ? this.page - 1 : 0);
    paramString += '&pageSize=' + this.pageSize;
    paramString += '&recurring=0';

    this.subscriptionGroup.push(this.tableDataService.getApiListData('EntryList', '?' + paramString).subscribe((result: ResponseModel) => {
      this.vm.listData = result.Data;
      this.totalRecords = result.totalRecords;
      this.paginate(false);

      this.convertToNumbers();
      this.vm.searching = false;
      this.vm.listInitiated = true;
      this.isLoaded = true;
    }));

    paramString = '';
    paramString += 'batchType=1';
    paramString += '&search=' + ((this.vm.entrySearch) ? this.vm.entrySearch : '');
    paramString += '&fromDate=' + ((this.vm.entryFromDate) ? this.dateFilter.GetDateFormat(this.vm.entryFromDate) : '');
    paramString += '&toDate=' + ((this.vm.entryToDate) ? this.dateFilter.GetDateFormat(this.vm.entryToDate) : '');
    paramString += '&lockedBatches=' + ((this.vm.lockedBatches) ? this.vm.lockedBatches : '');
    paramString += '&numberOfResults=' + ((this.vm.entryNumberOfResults) ? this.vm.entryNumberOfResults : '');
    paramString += '&include=' + ((this.vm.include) ? this.vm.include : 'all');
    paramString += '&pageNumber=' + ((this.page !== 0) ? this.page - 1 : 0);
    paramString += '&pageSize=' + this.pageSize;

    this.subscriptionGroup.push(this.tableDataService.getData('t_batch', '?' + paramString).subscribe((result: any[]) => {
      this.vm.batches = result;
    }));

  }

  serverSearch(value) {
    this.vm.entrySearch = value.searchTerm;
    this.vm.entryFromDate = value.fromDate;
    this.vm.entryToDate = value.toDate;
    this.page = 1;
    this.getPagedApiData();
  }

  scrollTo(anchor: string): void {
    if (!this.vm.batchesHidden) {
      this.vps.scrollToAnchor(anchor);
    }
  }

  hideSearch() {
    this.vm.searchHidden = !this.vm.searchHidden;
  }

  // selectItem() {
  //   this.vm.owingSelected = this.vm.totalSelected = 0;
  //   let firstEntity = '';
  //   document.getElementById('pay-btn').classList.remove('d-none');
  //   document.getElementById('owingSelected').classList.remove('d-none');
  //   this.vm.itemsSelected = false;
  //   for (const list of this.vm.listData) {
  //     if ((document.getElementById(list.id) as HTMLInputElement).checked) {
  //       if (firstEntity == '') {
  //         this.vm.itemsSelected = true;
  //         firstEntity = list.entity_name;
  //       } else if (firstEntity != list.entity_name) {
  //         document.getElementById('pay-btn').classList.add('d-none');
  //         document.getElementById('owingSelected').classList.add('d-none');
  //       }
  //       this.vm.totalSelected += Number(list.header_total);
  //       this.vm.owingSelected += Number(list.header_owing);
  //       document.getElementById(list.id + '-tr').classList.add('success');
  //     } else {
  //       document.getElementById(list.id + '-tr').classList.remove('success');
  //     }
  //   }
  // }

  selectRow(rec: any, checked: boolean) {
    // console.log('rec val:' + rec + ' - ' + checked);
    if (this.checkAll && rec) {
      this.checkAll = false;
    }
    if (!checked) {
      this.vm.listData.forEach((item) => {
        if (item.id === rec) {
          item.selected = false;
        }
      });
    } else if (checked) {
      this.vm.listData.forEach((item) => {
        if (item.id === rec && !item.locked) {
          item.selected = true;
        }
      });
    }
    this.isAllChecked();

    // console.log('single select records' + JSON.stringify(this.vm.list));
  }

  selectAllRows(event: any) {
    if (!event) {
      this.vm.listData.forEach((item) => (item.selected = false));
    } else if (event) {
      // this.vm.list.forEach((item) => (item.selected = true));
      this.vm.listData.forEach((item) => {
        if (!item.locked) {
          item.selected = true;
        }
      });
    }
    // console.log('all select records: ' + JSON.stringify(this.vm.list));
  }

  isAllChecked(): boolean {
    const retVal = this.vm.listData.every((x) => x.selected === true);
    this.checkAll = retVal;
    return retVal;
  }

  confirmDeleteSelected() {
    if (this.vm.listData.filter(x => x.selected).length === 0) {
      this.notification.showWarningToast('No records selected to delete!');
      return;
    }

    const messages: string[] = [
      $localize`:Are you sure you want to Delete? @@areyousureyouwanttodelete:Are you sure you want to Delete?`,
      'Selected Count: ' + this.vm.listData.filter(x => x.selected).length,
    ];
    this.confirmDialogService.confirmThis(
      messages,
      () => {
        this.deleteSelected();
      },
      () => {
        this.notification.showSuccessToast($localize`:Delete Canceled @@deleteCanceled:Delete Canceled`);
      }
    );
  }


  deleteSelected() {
    // just need to send the header id to the api
    const arrayOfItemsToDelete = [];
    this.vm.listData.forEach((x) => {
      if (x.selected) {
        arrayOfItemsToDelete.push({header_id: x.id});
      }
    });

    if (!arrayOfItemsToDelete.length) {
      this.notification.showWarningToast('No records selected to delete!');
      return;
    }
    // console.log('selected recs: ' + JSON.stringify(arrayOfItemsToDelete));

    // makes action button spinner turn while deleting
    this.isLoaded = false;
    // pass array as body in a delete to api entryController
    this.subscriptionGroup.push(this.tableDataService.deleteDataByArray('entry', arrayOfItemsToDelete).subscribe((item: any) => {
      if (item) {
        //  console.log(item);
        if (item.Message === 'Success') {
          this.isLoaded = true;
          this.getPagedApiData();
        }
      }
    }));
  }


  clearSearch() {
    this.vm.entrySearch = this.vm.entryFromDate = this.vm.entryToDate = this.vm.entrySearchLocked = '';
    this.vm.entryNumberOfResults = '';
    this.vm.listData = [];
    this.vm.searching = false;
    this.page = 1;
    this.search();
  }

  search() {
    this.isLoaded = false;
    this.vm.searching = true;
    this.vm.batchId = undefined;
    this.vm.tempDescription = '';

    let paramString = '';
    paramString += 'search=' + ((this.vm.entrySearch) ? this.vm.entrySearch : '');
    paramString += '&fromDate=' + ((this.vm.entryFromDate) ? this.dateFilter.GetDateFormat(this.vm.entryFromDate) : '');
    paramString += '&toDate=' + ((this.vm.entryToDate) ? this.dateFilter.GetDateFormat(this.vm.entryToDate) : '');
    paramString += '&numberOfResults=' + ((this.vm.entryNumberOfResults) ? this.vm.entryNumberOfResults : '');
    paramString += '&include=' + ((this.vm.include) ? this.vm.include : 'all');
    paramString += '&pageNumber=' + ((this.page !== 0) ? this.page - 1 : 0);
    paramString += '&pageSize=' + this.pageSize;
    paramString += '&recurring=0';

    this.subscriptionGroup.push(this.tableDataService.getApiListData('EntryList', '?' + paramString).subscribe((result: ResponseModel) => {
      this.vm.listData = result.Data;
      this.totalRecords = result.totalRecords;
      this.paginate(false);

      this.convertToNumbers();
      this.vm.searching = false;
      this.vm.listInitiated = true;
      this.isLoaded = true;
      this.EntryCount = this.vm.listData.length;
    }));

    paramString = '';
    paramString += 'batchType=1';
    paramString += '&search=' + ((this.vm.entrySearch) ? this.vm.entrySearch : '');
    paramString += '&fromDate=' + ((this.vm.entryFromDate) ? this.dateFilter.GetDateFormat(this.vm.entryFromDate) : '');
    paramString += '&toDate=' + ((this.vm.entryToDate) ? this.dateFilter.GetDateFormat(this.vm.entryToDate) : '');
    paramString += '&lockedBatches=' + ((this.vm.lockedBatches) ? this.vm.lockedBatches : '');
    paramString += '&numberOfResults=' + ((this.vm.entryNumberOfResults) ? this.vm.entryNumberOfResults : '');
    paramString += '&include=' + ((this.vm.include) ? this.vm.include : 'all');

    this.subscriptionGroup.push(this.tableDataService.getData('t_batch', '?' + paramString).subscribe((result: any[]) => {
      this.vm.batches = result;
    }));

  }

  filter(filter) {
    this.vm.invoiceFilter = Object.assign(this.vm.invoiceFilter, filter);
    // this.localStorage.StorageSet('invoiceFilter', this.vm.invoiceFilter);
  }

  convertToNumbers() {
    for (const list of this.vm.listData) {
      list.header_amount = Number(list.header_amount);
      list.audit_sequence = Number(list.audit_sequence);
    }
  }

  updateBatchesSelectedInModal(batchId: string) {
    this.getBatchItems(batchId);
    // this.paginate(false);
  }

  getBatchItems(batchId) {
    this.vm.tempDescription = '';
    this.vm.batchId = batchId;
    this.vm.searching = true;
    this.vm.tempDescription = this.FilterObject(this.vm.batches, { id: this.vm.batchId }, true)[0].description;
    this.vm.tempBatchLocked = this.FilterObject(this.vm.batches, { id: this.vm.batchId }, true)[0].locked;
    this.subscriptionGroup.push(this.tableDataService.getData('EntryList/batch', '?batch_id=' + this.vm.batchId)
      .subscribe((result: any[]) => {
      this.convertToNumbers();
      this.vm.searching = false;
      this.vm.listData = result;
      this.vm.listInitiated = true;
    }));
  }

  getBatches() {
    this.vm.searching = true;
    let paramString = '';
    paramString += 'batchType=1';
    paramString += '&search=' + ((this.vm.invoiceSearch) ? this.vm.invoiceSearch : '');
    paramString += '&fromDate=' + ((this.vm.invoiceFromDate) ? this.dateFilter.GetDateFormat(this.vm.invoiceFromDate) : '');
    paramString += '&toDate=' + ((this.vm.invoiceToDate) ? this.dateFilter.GetDateFormat(this.vm.invoiceToDate) : '');
    paramString += '&lockedBatches=' + ((this.vm.lockedBatches) ? this.vm.lockedBatches : '');
    paramString += '&entryNumberOfResults=' + ((this.vm.entryNumberOfResults) ? this.vm.entryNumberOfResults : '');
    paramString += '&include=' + ((this.vm.include) ? this.vm.include : 'all');

    this.tableDataService.getData('t_batch', '?' + paramString).subscribe((result: any[]) => {
      this.vm.batches = result;
      if (this.FilterObject(this.vm.batches, { id: this.vm.batchId }, true).length == 1) {
        this.vm.tempDescription = this.FilterObject(this.vm.batches, { id: this.vm.batchId }, true)[0].description;
        this.vm.tempBatchLocked = this.FilterObject(this.vm.batches, { id: this.vm.batchId }, true)[0].locked;
      }
      this.vm.searching = false;
    });
  }

  newBatch() {
    const newBatch = { type_id: 1 };
    this.subscriptionGroup.push(this.tableDataService.post('t_batch', newBatch).subscribe((item: any) => {
      this.getBatches();
      this.vm.batchId = item.id;
      this.vm.tempDescription = 'Batch';
    }, (error) => {
      this.vm.buttonsDisabled = false;
      console.log(error);
    }));
  }

  updateBatch() {
    this.vm.buttonsDisabled = true;
    const changes = { description: this.vm.tempDescription };
    this.tableDataService.patch('t_batch', this.vm.batchId, changes).then((item: any) => {
      // this.notification.success(this.vm.tempDescription);
      this.getBatches();
    }, (error: any) => {
      this.vm.buttonsDisabled = false;
      console.log(error.description);
    });
  }

  postBatch(batchId) {
    this.vm.buttonsDisabled = true;
    const changes = { locked: 'true' };
    this.tableDataService.patch('t_batch', batchId, changes).then((item: any) => {
      // this.notification.success('success');
      this.getBatches();
      this.vm.buttonsDisabled = false;
    }, (error: any) => {
      this.vm.buttonsDisabled = false;
      console.log(error.description);
    });
  }

  hideBatches() {
    // this.vm.buttonsDisabled = true;
    this.vm.batchesHidden = !this.vm.batchesHidden;
    this.vm.Preferences.ShowBatches = !this.vm.batchesHidden;
  }

  FilterObject(value, filterObj, except = false) {
    return new FilterPipe().transform(value, filterObj);
  }

  ngAfterViewInit() {
    this.titleService.setTitle(this.vm.title);

  }

  onNavigate(aID: string, print = false) {
    if (this.vm.batchId == undefined) {
      this.vm.batchId = '';
    }
    this.router.navigateByUrl(this.vm.formRouter + '?entryId=' + aID + '&thisBatchId=' + this.vm.batchId + '&recurring=false').then();
  }


}
